import ChatTranslate from './ChatTranslate';

export default ChatTranslate;
